/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Button, DialogContentText } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { DialogDefaultV2 } from '../../../components/v2';
import { REPROCESS_BATCH_LIMIT, REPROCESS_CONFIRM_THRESHOLD } from './constants';
import ReprocessBatchDialog from './ReprocessBatchDialog';

const ErroBanner = ({ errorCount, apiFilter, onReload }) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openBatch, setOpenBatch] = useState(false);

  if (!errorCount || errorCount <= 0) {
    return null;
  }

  const startBatch = () => {
    setOpenConfirm(false);
    setOpenBatch(true);
  };

  const onReprocessClick = () => {
    if (errorCount >= REPROCESS_CONFIRM_THRESHOLD) {
      setOpenConfirm(true);
    } else {
      startBatch();
    }
  };

  const estimatedBatches = Math.ceil(errorCount / REPROCESS_BATCH_LIMIT);

  return (
    <>
      <Alert
        severity="error"
        variant="filled"
        sx={{
          borderRadius: 2,
          alignItems: 'center',
          '& .MuiAlert-message': { flex: 1 },
        }}
        action={
          <Button
            color="inherit"
            disabled={openBatch}
            onClick={onReprocessClick}
            size="small"
            startIcon={<ReplayIcon />}
            variant="outlined"
            sx={{ borderColor: 'rgba(255,255,255,0.5)', whiteSpace: 'nowrap' }}
          >
            Reprocessar erros
          </Button>
        }
      >
        <Box component="span" sx={{ fontWeight: 600 }}>
          {errorCount}
        </Box>
        {` integração${errorCount !== 1 ? 'ões' : ''} com erro no período filtrado`}
      </Alert>

      <DialogDefaultV2
        open={openConfirm}
        handlerCancel={() => setOpenConfirm(false)}
        handlerConfirm={startBatch}
        title="Reprocessar erros em lote"
        confirmMessage="Iniciar"
        cancelMessage="Cancelar"
        maxWidth="sm"
        fullWidth
      >
        <DialogContentText>
          Serão reprocessadas até {errorCount} integrações com erro, em lotes de{' '}
          {REPROCESS_BATCH_LIMIT} (cerca de {estimatedBatches} chamadas ao servidor).
          A tela ficará bloqueada até concluir ou cancelar.
        </DialogContentText>
      </DialogDefaultV2>

      <ReprocessBatchDialog
        open={openBatch}
        apiFilter={apiFilter}
        initialTotal={errorCount}
        onClose={() => setOpenBatch(false)}
        onComplete={onReload}
      />
    </>
  );
};

ErroBanner.propTypes = {
  errorCount: PropTypes.number,
  apiFilter: PropTypes.object.isRequired,
  onReload: PropTypes.func.isRequired,
};

ErroBanner.defaultProps = {
  errorCount: 0,
};

export default ErroBanner;
